<div class="wrapper rows">
    <div class="box content-wrapper" *ngFor="let product of products">
        <img class="row-img" src="{{product?.imageUrl}}"> 
        <div class="info-wrapper">
            <div class="info">
                <ul class="product-links">
                    <li class="link-item"><a href="#"><i class="fa fa-shopping-bag"></i></a></li>
                    <li class="link-item"><a href="#"><i class="fas fa-heart"></i></a></li>
                    <li class="link-item"><a href="#"><i class="fa fa-search"></i></a></li>
                </ul>
                <div class="details">
                    <p>Product Name</p>
                    <p>Price: R99.00</p>
                </div>
            </div>
        </div>
    </div>   
</div>
